import React from "react";
import { Col, Form, Row, Select } from "antd";
import BannerCard from "../../common/components/BannerCard";
import { useSelector } from "react-redux";
import { RootState } from "../../store";

const TRCRDailyCaseQuery = ({ ...props }) => {
  const { queryList } = useSelector((state: RootState) => state.queryApi);
  return (
    <BannerCard title="Select Judge">
      <Row gutter={[12, 12]}>
        <Col xl={6} lg={6} md={6} sm={24} xs={24}>
          <Form.Item label="Type" name="type">
            <Select placeholder="Select a type" onChange={(value) => props.handleTypeChange(value)}>
              {React.Children.toArray(
                props.allTypes?.map((eachType) => {
                  return <Select.Option value={eachType.index}>{eachType.value}</Select.Option>;
                })
              )}
            </Select>
          </Form.Item>
        </Col>
        <Col xl={18} lg={18} md={18} sm={24} xs={24}>
          <Form.Item label="Judge 1" name="startJudge" rules={[{ required: props.type !== props.allTypes[0].index ? true : false }]}>
            <Select placeholder="Select a judge" disabled={props.type === props.allTypes[0].index ? true : false}>
              {React.Children.toArray(
                queryList?.LIST?.map((eachData) => {
                  return <Select.Option value={eachData.VALUE}>{eachData.LABEL}</Select.Option>;
                })
              )}
            </Select>
          </Form.Item>
          {props.type === props.allTypes[2].index && (
            <Form.Item label="Judge 2" name="endJudge" rules={[{ required: true }]}>
              <Select placeholder="Select a judge">
                {React.Children.toArray(
                  queryList?.LIST?.map((eachData) => {
                    return <Select.Option value={eachData.VALUE}>{eachData.LABEL}</Select.Option>;
                  })
                )}
              </Select>
            </Form.Item>
          )}
        </Col>
      </Row>
    </BannerCard>
  );
};

const TRCRArraignmentCaseQuery = ({ ...props }) => {
  return (
    <BannerCard title="Select Judge">
      <Row gutter={[12, 12]}>
        <Col xl={6} lg={6} md={6} sm={24} xs={24}>
          <Form.Item label="Type" name="type">
            <Select placeholder="Select a type" />
          </Form.Item>
        </Col>
        <Col xl={18} lg={18} md={18} sm={24} xs={24}>
          <Form.Item label="Judge" name="judge">
            <Select placeholder="Select a judge" />
          </Form.Item>
        </Col>
      </Row>
    </BannerCard>
  );
};

const TRCRAttorneyCaseQuery = ({ ...props }) => {
  const { queryList } = useSelector((state: RootState) => state.queryApi);
  return (
    <BannerCard title="Select Attorney">
      <Row gutter={[12, 12]}>
        <Col xl={6} lg={6} md={6} sm={24} xs={24}>
          <Form.Item label="Type" name="type">
            <Select placeholder="Select a type" onChange={(value) => props.handleTypeChange(value)}>
              {React.Children.toArray(
                props.allTypes?.map((eachType) => {
                  return <Select.Option value={eachType.index}>{eachType.value}</Select.Option>;
                })
              )}
            </Select>
          </Form.Item>
        </Col>
        <Col xl={18} lg={18} md={18} sm={24} xs={24}>
          <Form.Item label="Attorney 1" name="startAttorney" rules={[{ required: props.type !== props.allTypes[0].index ? true : false }]}>
            <Select placeholder="Select an attorney" disabled={props.type === props.allTypes[0].index ? true : false}>
              {React.Children.toArray(
                queryList?.LIST?.map((eachData) => {
                  return <Select.Option value={eachData.VALUE}>{eachData.LABEL}</Select.Option>;
                })
              )}
            </Select>
          </Form.Item>
          {props.type === props.allTypes[2].index && (
            <Form.Item label="Attorney 2" name="endAttorney" rules={[{ required: true }]}>
              <Select placeholder="Select an attorney" disabled={props.type === props.allTypes[0].index ? true : false}>
                {React.Children.toArray(
                  queryList?.LIST?.map((eachData) => {
                    return <Select.Option value={eachData.VALUE}>{eachData.LABEL}</Select.Option>;
                  })
                )}
              </Select>
            </Form.Item>
          )}
        </Col>
      </Row>
    </BannerCard>
  );
};

const TRCRAgencyCaseQuery = ({ ...props }) => {
  const { queryList } = useSelector((state: RootState) => state.queryApi);
  return (
    <BannerCard title="Select Agency">
      <Row gutter={[12, 12]}>
        <Col xl={6} lg={6} md={6} sm={24} xs={24}>
          <Form.Item label="Type" name="type">
            <Select placeholder="Select a type" onChange={(value) => props.handleTypeChange(value)}>
              {React.Children.toArray(
                props.allTypes?.map((eachType) => {
                  return <Select.Option value={eachType.index}>{eachType.value}</Select.Option>;
                })
              )}
            </Select>
          </Form.Item>
        </Col>
        <Col xl={18} lg={18} md={18} sm={24} xs={24}>
          <Form.Item label="Agency 1" name="startAgency" rules={[{ required: props.type !== props.allTypes[0].index ? true : false }]}>
            <Select placeholder="Select an agency" disabled={props.type === props.allTypes[0].index ? true : false}>
              {React.Children.toArray(
                queryList?.LIST?.map((eachData) => {
                  return <Select.Option value={eachData.VALUE}>{eachData.LABEL}</Select.Option>;
                })
              )}
            </Select>
          </Form.Item>
          {props.type === props.allTypes[2].index && (
            <Form.Item label="Agency 2" name="endAgency" rules={[{ required: true }]}>
              <Select placeholder="Select an agency" disabled={props.type === props.allTypes[0].index ? true : false}>
                {React.Children.toArray(
                  queryList?.LIST?.map((eachData) => {
                    return <Select.Option value={eachData.VALUE}>{eachData.LABEL}</Select.Option>;
                  })
                )}
              </Select>
            </Form.Item>
          )}
        </Col>
      </Row>
    </BannerCard>
  );
};

const QueryDropdowns = () => {
  return <></>;
};

QueryDropdowns.TRCRDailyCaseQuery = TRCRDailyCaseQuery;
QueryDropdowns.TRCRArraignmentCaseQuery = TRCRArraignmentCaseQuery;
QueryDropdowns.TRCRAttorneyCaseQuery = TRCRAttorneyCaseQuery;
QueryDropdowns.TRCRAgencyCaseQuery = TRCRAgencyCaseQuery;

export default QueryDropdowns;
